

exports.__esModule = true;
exports.$FLOWS = void 0;
var _squid = require("squid");
exports.$integration = _squid.$integration;
exports.$CONTEXT = _squid.$CONTEXT;
var _$DEFAULT, _$CONTEXT$FULLPAGE, _$integration$init;
var $FLOWS = exports.$FLOWS = {
  // Regular end-to-end checkout flow with one entry and one exit point
  CHECKOUT: 'CHECKOUT',
  // Partner flow [ TODO: FACTOR THIS OUT ]
  PARTNER: 'PARTNER',
  // Native checkout flow
  NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};
_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {
  REDIRECT_TOP: true,
  REDIRECT_QUERY_PARAM: false
}, _$DEFAULT[$FLOWS.PARTNER] = {
  REDIRECT_TOP: false,
  REDIRECT_QUERY_PARAM: true
}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
  REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = {
  REDIRECT_TOP: false
}, _$integration$init));
angular.value("$FLOWS", $FLOWS);
_squid.$integration;
_squid.$DEFAULT;
_squid.$CONTEXT;


//////////////////
// WEBPACK FOOTER
// ./js/lib/integration.js
// module id = ./js/lib/integration.js
// module chunks = 0